<!-- ========== MAIN CONTENT ========== -->
<page-load-header *ngIf="!initialized"></page-load-header>
<main (resized)="onResized($any($event))" *ngIf="initialized" id="content" role="main">  

  <div *ngIf="events && events.length > 0" class="container pt-6">
    <!-- Title -->
    <div class="d-sm-flex justify-content-sm-between align-items-sm-center mb-5">
      <h2 class="h3 font-weight-medium">{{ 'my-upcoming-events' | translate }}</h2>
      <a class="link-muted" [routerLink]="['/account/events']">
        {{ 'view-all' | translate }}
        <span class="fas fa-angle-right small ml-2"></span>
      </a>
    </div>
    <!-- End Title -->

    <div class="row">
      <ng-container *ngFor="let event of events">
        <div class="col-xl-3 col-lg-4 col-md-6 d-flex">
          <bxl-conference-item *ngIf="event.conference?.id" [conference]="event.conference" [isGrid]="true"></bxl-conference-item>
          <bxl-event-item *ngIf="event.event?.id"  [event]="event.event" [isGrid]="true"></bxl-event-item>
        </div>
      </ng-container>
    </div>
  </div>

  <div *ngIf="courses && courses.length > 0" class="position-relative overflow-hidden">
    <div class="container pt-6 pb-6">
      <!-- Title -->
      <div class="d-sm-flex justify-content-sm-between align-items-sm-center mb-5">
        <h2 class="h3 font-weight-medium">My Library</h2>
        <a class="link-muted" [routerLink]="['/account/library']">
          {{ 'view-all' | translate }}
          <span class="fas fa-angle-right small ml-2"></span>
        </a>
      </div>
      <!-- End Title -->
      
      <div class="row">
        <div *ngIf="courses && courses.length > 4" class="col-md-12">
          <p-carousel [numVisible]="5" [value]="courses" [responsiveOptions]="responsiveOptions2">
            <ng-template let-course pTemplate="item">
              <div [routerLink]="['/courses', course.slug]" class="card cursor-pointer d-flex h-100">
                <bxl-course-item [course]="course" [displayPrice]="false" [displayArchiveDate]="true" [isGrid]="true"></bxl-course-item>
              </div>
            </ng-template>
          </p-carousel>
        </div>
        <ng-container *ngIf="courses && courses.length > 0 && courses.length < 5">
          <ng-container  *ngFor="let course of courses">
            <div [routerLink]="['/courses', course.slug]" class="col-xl-3 col-lg-4 col-md-6 mb-3 cursor-pointer d-flex">
              <div class="card">
                <bxl-course-item [course]="course" [displayPrice]="false" [displayArchiveDate]="true" [isGrid]="true"></bxl-course-item>
              </div>
            </div>
          </ng-container>
        </ng-container>
      </div>
    </div>
  </div>

  <div id="SVGbgElements6" class="position-relative overflow-hidden">
    <div class="container pt-6">
      <!-- Title -->
      <div class="d-sm-flex justify-content-sm-between align-items-sm-center mb-5">
        <h2 class="h3 font-weight-medium">{{ 'featured-on-demand-content' | translate }}</h2>
        <a class="link-muted" [routerLink]="['/course-library']">
          {{ 'search-library' | translate }}
          <span class="fas fa-angle-right small ml-2"></span>
        </a>
      </div>
      <!-- End Title -->

      <div class="row">
        <div *ngIf="!featuredCourses" class="col-md-12">
          <p-skeleton width="100%" height="200px"></p-skeleton>
        </div>
        <div *ngIf="featuredCourses && !showExpandedFeaturedCourses" class="col-md-12">
          <p-carousel [numVisible]="5" [value]="featuredCourses" [responsiveOptions]="responsiveOptions2">
            <ng-template let-course pTemplate="item">
              <div [routerLink]="['/courses', course.slug]" class="card cursor-pointer d-flex h-100">
                <bxl-course-item [course]="course" [isGrid]="true"></bxl-course-item>
              </div>
            </ng-template>
          </p-carousel>
        </div>
        <ng-container *ngIf="featuredCourses && showExpandedFeaturedCourses">
          <ng-container *ngFor="let featuredCourse of featuredCourses">
            <div [routerLink]="['/courses', featuredCourse.slug]" class="col-xl-3 col-lg-4 col-md-6 mb-3 cursor-pointer d-flex">
              <div class="card">
                <bxl-course-item [course]="featuredCourse" [isGrid]="true"></bxl-course-item>
              </div>
            </div>
          </ng-container>
        </ng-container>
      </div>
    </div>

    <!-- SVG Background Element -->
    <figure class="position-absolute top-0 right-0 z-index-n1 w-100 h-100">
      <img class="js-svg-injector" src="../../assets/svg/components/bg-elements-6.svg" alt="SVG" data-parent="#SVGbgElements6" />
    </figure>
    <!-- End SVG Background Element -->
  </div>
</main>
<!-- ========== END MAIN CONTENT ========== -->
<!-- ========== MAIN CONTENT ========== -->

<!-- ========== END MAIN CONTENT ========== -->
